/* eslint-disable */

import axios from 'axios'
import constants from '../constants/constants'
// TODO fix
// eslint-disable-next-line import/no-cycle
import {
  SUBMITTING_AMBASSADOR_FORM,
  SUBMITTED_AMBASSADOR_FORM,
  ERROR_SUBMITTING_AMBASSADOR_FORM,
  UPDATING_AMBASSADOR,
  ERROR_UPDATING_AMBASSADOR,
  ADD_PENDING_PAYMENT,
  CREATING_PENDING_PAYMENT,
  ERROR_FETCHING_AMBASSADOR_PAYMENTS,
  FETCHING_AMBASSADOR_CAMPAIGNS,
  RECEIVED_AMBASSADOR_CAMPAIGNS,
  ERROR_FETCHING_AMBASSADOR_CAMPAIGNS,
  updateField,
  fetchData
} from './index'
import {
  FETCHING_AMBASSADOR_AUDIENCE,
  RECEIVED_AMBASSADOR_AUDIENCE,
  ERROR_FETCHING_AMBASSADOR_AUDIENCE
} from './constants/ambassadors'
import { FOLLOWING_USER } from './constants/users'

export const fetchAmbassadorAudience = (ambassadorId) => (dispatch) => {
  dispatch({
    type: FETCHING_AMBASSADOR_AUDIENCE
  })
  return axios
    .get(`${constants.api.ambassadors}influencers/${ambassadorId}/audience`)
    .then((res) => {
      dispatch({
        type: RECEIVED_AMBASSADOR_AUDIENCE,
        data: res.data
      })
    })
    .catch(() => {
      dispatch({
        type: ERROR_FETCHING_AMBASSADOR_AUDIENCE
      })
    })
}

export const followAllAudience =
  ({ viewerID, ambassadorID, toFollow }) =>
  (dispatch) => {
    if (!viewerID || !ambassadorID || (toFollow && !toFollow.length)) return
    toFollow.forEach((id) => {
      dispatch({
        type: FOLLOWING_USER,
        viewerID,
        userID: id
      })
    })

    axios.patch(
      `${constants.api.ambassadors}influencers/${ambassadorID}/follow-all-audience`
    )
  }

export const submitForm =
  ({ form }) =>
  (dispatch) => {
    dispatch({ type: SUBMITTING_AMBASSADOR_FORM })
    axios
      .post(`${constants.api.ambassadors}influencers`, form)
      .then((res) => {
        if (res.data.success) {
          dispatch({ type: SUBMITTED_AMBASSADOR_FORM })
        }
      })
      .catch((error) => {
        console.error(error.response)
        dispatch({ type: ERROR_SUBMITTING_AMBASSADOR_FORM })
      })
  }

export const update =
  ({ _id, type, firstName, lastName, email, address, paypalEmail }) =>
  (dispatch) => {
    let toUpdate = {}
    dispatch({ type: UPDATING_AMBASSADOR })
    if (type === 'general') {
      if (!firstName || !lastName || !email || !_id) return
      toUpdate = {
        ...(address && { address }),
        firstName,
        lastName,
        email,
        paypalEmail
      }
    }

    if (type === 'paypal') {
      if (!_id) return
      toUpdate = {
        paypalEmail
      }
    }

    axios
      .put(`${constants.api.ambassadors}influencers/${_id}`, toUpdate)
      .then(() => {
        dispatch(
          updateField({
            type: 'ambassadors',
            _id,
            value: toUpdate
          })
        )
      })
      .catch((err) => {
        console.error(err)
        dispatch({ type: ERROR_UPDATING_AMBASSADOR })
      })
  }

export const submitPayment =
  ({ ambassadorID }) =>
  (dispatch) => {
    dispatch({ type: CREATING_PENDING_PAYMENT })
    axios
      .post(`${constants.api.ambassadors}influencers/${ambassadorID}/payments`)
      .then((res) => {
        // create a pending payment in redux too
        dispatch({
          type: ADD_PENDING_PAYMENT,
          payment: res.data.payment
        })
        dispatch(
          fetchData({
            path: `${constants.api.ambassadors}influencers/${ambassadorID}`,
            type: 'ambassadors',
            subtype: 'ambassador'
          })
        )
      })
      .catch((err) => {
        console.error(err)
        dispatch({ type: ERROR_FETCHING_AMBASSADOR_PAYMENTS })
      })
  }

export const fetchActiveCampaigns = (dispatch) => {
  dispatch({ type: FETCHING_AMBASSADOR_CAMPAIGNS })
  axios
    .get(`${constants.api.ambassadors}active-campaigns`)
    .then((res) => {
      dispatch({
        type: RECEIVED_AMBASSADOR_CAMPAIGNS,
        data: res.data
      })
    })
    .catch((error) => {
      dispatch({
        type: ERROR_FETCHING_AMBASSADOR_CAMPAIGNS,
        error
      })
    })
}
